import React from 'react';
import Logo from '../assets/a.png';
import Contact from './Contact';

const Header = () => {
  return <header className='py-8'>
    <div className='container mx-auto'>
      <div className='flex justify-between items-center'>
        <a href='#about'>
          <button className='font-bold shadow-xl'>athuls here</button>
        </a>
        <a href='#contact'>
        <button className='btn btn-sm'>Work with me</button>
        </a>
      </div>
    </div> 
  </header>;
};

export default Header;
